/**
 * Marketing forms POST here. Default is same-origin `/api/contact` (Caddy proxies to
 * website/server/contact-api.mjs on the droplet; Vite dev proxies to localhost:8788).
 * For Vercel serverless or another host, set VITE_CONTACT_API_URL at build time.
 */
export function contactApiUrl(): string {
  const v = import.meta.env.VITE_CONTACT_API_URL as string | undefined;
  if (typeof v === "string" && v.trim()) {
    return v.trim().replace(/\/$/, "");
  }
  return "/api/contact";
}
